import { render, staticRenderFns } from "./main-applicant.vue?vue&type=template&id=2018f638"
import script from "./main-applicant.vue?vue&type=script&lang=js"
export * from "./main-applicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports